export default "__VITE_ASSET__Bl4Iqh77__"